import React from 'react'
import { View } from 'react-native'
import { BottomSheet } from '@src/components'
import { Icon, Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useGoBack } from '@src/utils'

export const CheckInCompletedModal = () => {
  const styles = useStyleSheet(themedStyles)
  const goBack = useGoBack()

  return (
    <BottomSheet
      buttonDirection="column-reverse"
      secondaryButton={{ text: 'Dismiss', onPress: goBack }}
    >
      <View style={styles.iconContainer}>
        <Icon name="check-circle" style={styles.icon} weight="duotone" />
      </View>
      <Text style={styles.content} type="title-2">
        You have completed your call check in.
      </Text>
      <Text style={styles.content} type="regular">
        If you'd like to add additional information for your next call, you can do so in the call
        detail screen.
      </Text>
    </BottomSheet>
  )
}

const themedStyles = StyleService.create({
  content: {
    textAlign: 'center',
    margin: 8,
  },
  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: 48,
    height: 48,
  },
})
